import { Component, OnInit, ViewChild, ElementRef, PLATFORM_ID, Inject, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { NeproseService } from '../services/neprose.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material/snack-bar';
import { WindowRef } from '../Window/WindowRef';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';

@Component({
  selector: 'app-blog-single-page',
  templateUrl: './blog-single-page.component.html',
  styleUrls: ['./blog-single-page.component.css']
})
export class BlogSinglePageComponent implements OnInit {

  title: string

  slug: string

  categoryList = []

  post: any

  url: any

  similarList = []

  blogInstance: any

  isBrowser: boolean

  @ViewChild('commentSection') commentSection: ElementRef;  

  constructor( private neproseService: NeproseService, private _route: ActivatedRoute, private _sanitizer: DomSanitizer,
    private router: Router, private _notification: MatSnackBar,
      private changeDetectorRef: ChangeDetectorRef, private renderer: Renderer2,
     @Inject(PLATFORM_ID) protected platformId: Object, private window: WindowRef, private seo: SeoSocialShareService) {
       this.isBrowser = isPlatformBrowser(this.platformId)
     }

  ngOnInit() {
    this.title = this._route.snapshot.params.slug
    this._route.data.subscribe((data:{blog: any})=> {
      this.blogInstance = data.blog
      this.seo.setTitle(this.blogInstance.title)
      if(this.blogInstance.imagePath){
        this.seo.setImage(environment.api+'/images/'+this.blogInstance.imagePath)
      }
      let excerpt = this.blogInstance.body.replace(/<\/?[^>]+(>|$)/g, '')
      if(excerpt){
        this.seo.setDescription(excerpt.slice(0, 200))
      }
      this.getPost()
    })
  }


  initializeShareButton(){
    if(isPlatformBrowser(this.platformId)){
      this.window.nativeWindow.__sharethis__.load('inline-share-buttons', {
        alignment: 'center',
        id: 'my-inline-share-buttons',
        enabled: true,
        font_size: 12,
        padding: 10,
        radius: 20,
        labels: 'none',
        networks: ['facebook', 'twitter', 'linkedin', 'messenger', 'whatsapp'],
        size: 40,
        show_mobile_buttons: true,
        show_total: true,
        spacing: 8,
        url: this.url,
      })
      this.window.nativeWindow.__sharethis__.initialize();
    }
  }

  getPost(){
    this.url = environment.url + '/blog/' + this.slug
    let post = Object.assign({}, this.blogInstance)
    post['createdDate'] = new Date(post.createdAt).toDateString()
    if(post.authorImage){
      post['authorImage'] = environment.api+'/images/'+post.authorImage
    }
    if(post.imagePath){
      post.imagePath = this._sanitizer.bypassSecurityTrustStyle(`url(${environment.api}`+`/images/`+`${post.imagePath})`+` no-repeat center center`)
    }
    this.post = post
    this.getPosts()
    this.changeDetectorRef.detectChanges()
    if(isPlatformBrowser(this.platformId)){
      this.renderer.setAttribute(this.commentSection.nativeElement, 'data-href', this.url)
      if(this.window.nativeWindow.FB){
        this.window.nativeWindow.FB.XFBML.parse()
      }
      this.initializeShareButton()
    }
  }

  commentURL(){
    return this.url;
  }

  getPosts(){
    this.similarList = []
    this.neproseService.getBlogs(0, 'new').subscribe(data => {
      if(data.status){
        let blogList = data.blogs
        if(blogList.length > 0){
          for(let blog of blogList){
            if((blog.id != this.post.id) && (this.similarList.length < 3)){
              blog['featuredImage'] = environment.api + '/images/' + blog['imagePath']
              blog['publishedDate'] = new Date(blog['updatedAt']).toDateString()
              let excerpt = blog.body.replace(/<\/?[^>]+(>|$)/g, '')
              let blogLength = excerpt.length
              let minRead = Math.ceil(blogLength/1000)
              if(minRead > 1){
                blog['minRead'] = minRead +' mins read'
              }else{
                blog['minRead'] = minRead +' minute read' 
              }
              if(excerpt){
                blog['excerpt'] = excerpt.slice(0, 300)
              }else{
                blog['excerpt'] = ''
              }
              this.similarList.push(blog)
            }   
          }
        }
      }
    })
  }

  openNotification(message: any){
    this._notification.open(message, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }


}
